import React, { useEffect, useState } from 'react'
import { GetAll_Period_Api } from '../../API/PeriodApi';
// ======================================================================
import { useCallback } from 'react';
import { Select, Tag } from 'antd';
// ======================================================================
const { Option } = Select;

const STATUS_OPTIONS = [
    { value: null, label: "همه وضعیت ها", color: 'default' },
    { value: 3, label: "در انتظار قرعه کشی", color: 'orange' },
    { value: 4, label: "برنده شده در قرعه کشی", color: 'green' },
    { value: 5, label: "برنده نشده در قرعه کشی", color: 'red' },
    { value: 6, label: "در انتظار ارسال مدارک", color: 'blue' },
    { value: 7, label: "در انتظار پرداخت", color: 'gold' },
    { value: 8, label: "پرداخت شده", color: 'green' },
    { value: 9, label: "قطعی شده", color: 'cyan' },
    { value: 10, label: "پذیرش شده", color: 'success' },
    { value: 11, label: "لیست انتظار", color: 'red' },
    { value: 12, label: "انصراف قطعی", color: 'error' }
];

export const ReserveStatusCombo = ({ onChange, value }) => {
    const handleChange = useCallback((selectedValue) => {
        onChange?.(selectedValue);
    }, [onChange]);

    const getTagRender = useCallback(({ value: currentValue, onClose }) => {
        const option = STATUS_OPTIONS.find(opt => opt.value === currentValue);
        if (!option || option.value === null) return null;
        
        return (
            <Tag 
                color={option.color} 
                onClose={onClose}
                closable
            >
                {option.label}
            </Tag>
        );
    }, []);

    return (
        <Select
            style={{ width: '100%' }}
            value={value}
            onChange={handleChange}
            placeholder="همه وضعیت ها"
            showSearch
            allowClear
            tagRender={getTagRender}
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
        >
            {STATUS_OPTIONS.map(({ value, label, color }) => (
                <Option key={value} value={value}>
                    <Tag color={color} style={{ marginRight: 8 }}>
                        {label}
                    </Tag>
                </Option>
            ))}
        </Select>
    );
};